// Native
import { Badge, Box, Button, Flex, Grid, GridItem, HStack, Spinner, Text, useDisclosure } from "@chakra-ui/react"

// Custom
import { Parts, UI } from "components"
import { Styles } from "config"
import useNetwork from "hooks/useNetwork"
import { useState } from "react"
import { useNavigate } from "react-router"
import Search from "./search"

export default function Network(){

    const navigate = useNavigate()
    const network = useNetwork()
    const [ downline, setDownline ] = useState()
    const search = useDisclosure()

    return(
    <>
    <Parts.Dialog.Network.Downline open={!!downline} data={{...downline, id: downline?.consultant_id}} onClose={() => setDownline(false)} />
    <Search {...search} />
    <UI.Header title="Rede" />

    <Grid templateColumns={{ sm: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }} gap={4}>

        <GridItem>

            {/* Cadastrar Downline */}
            <Parts.Widgets.DownlineRegister h="auto" mb={4} />

            {/* Resumo da rede */}
            <Parts.Widgets.Network.Resume h="auto"><Button mt={4} variant="subtle" size="xs" onClick={() => navigate('/pontos')}><UI.Icon name="points" /> Ver downlines e pontuação</Button></Parts.Widgets.Network.Resume>

        </GridItem>

        <GridItem><Parts.Widgets.Network.Analytics /></GridItem>

        <GridItem><Parts.Widgets.Network.Pins /></GridItem>

    </Grid>

    <Flex alignItems="center" justifyContent="space-between" mt={4}>
        <Text children="Sua rede:" color="GrayText" my={4} />
        <Button size="xs" variant="ghost" onClick={search.onOpen}><UI.Icon name="search" /> Procurar na sua rede</Button>
    </Flex>

    <UI.Show visible={network.isFetching}><UI.Alert indicator={<Spinner />} colorPalette="gray" mb={3} size="sm" title="Carregando sua rede..." /></UI.Show>

    <UI.Accordion.AccordionRoot lazyMount unmountOnExit variant="enclosed">

        { Object.keys(network.data ?? {}).map(level => {

            const downlines = Object.keys(network.data[level])

            return(
            <UI.Accordion.AccordionItem key={level} value={level}>
                <UI.Accordion.AccordionItemTrigger>Nível {level} <Badge>{downlines?.length} cadastrados</Badge></UI.Accordion.AccordionItemTrigger>
                <UI.Accordion.AccordionItemContent>
                    <Grid templateColumns={{ base: '1fr', sm: '1fr', md: 'repeat(3, 1fr)', lg: 'repeat(4, 1fr)' }} gap={4}>

                        { downlines?.map(item => {
                            const downline = network.data[level][item]
                            const amStyle = Styles.activeMonth(parseInt(downline.active_month_status))
                            const cStyle = Styles.pin(downline.career_id)

                            return(
                            <GridItem key={downline.consultant_id}>
                                <UI.Pressable onClick={() => setDownline(downline)}>
                                    <Box direction="column" alignItems="center" justifyContent="center" py={2} px={4} borderRadius={4} maxH="110px" backgroundColor={`${cStyle.colorPalette}.subtle`}>
                                        <UI.Avatar name={downline.name} src={item?.career_image_url} colorPalette={cStyle.colorPalette} />
                                        <Text fontSize="xs" fontWeight="bold" textTransform="capitalize">{downline.name}</Text>
                                        <HStack mt={2}>
                                            <Badge colorPalette={cStyle.colorPalette}>{downline?.career_title}</Badge>
                                            <Badge colorPalette={amStyle.colorPalette}>{amStyle.label}</Badge>
                                        </HStack>
                                    </Box>
                                </UI.Pressable>
                            </GridItem>
                            )

                        }) }
                        

                    </Grid>
                </UI.Accordion.AccordionItemContent>
            </UI.Accordion.AccordionItem>
            )
        })}
        

    </UI.Accordion.AccordionRoot>
    </>
    )
}